
/**
 * Angular imports
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

/**
 * Module imports
 */
import { ProductSubscribeModule } from './../../common/product-subscribe/product-subscribe.module';
import { CustomTooltipModule } from './../../common/custom-tooltip/custom-tooltip.module';
import { DirectivesModule } from './../../directives/directives.module';
import { UserProfilePicModule } from './../../common/user-pofile-pic/user-profile-pic.module';
import { InfoModalModule } from '../../common/info-modal/info-modal.module';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AnalyticsEventModule } from '../../analytics-event/analytics-event.module';
import { PipesModule } from '../../pipes/pipes.module';

/**
 * Component imports
 */
import { ConnectionCardComponent } from './connection-card.component';


@NgModule({
  declarations: [
    ConnectionCardComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    UserProfilePicModule,
    DirectivesModule,
    CustomTooltipModule,
    ProductSubscribeModule,
    InfoModalModule,
    NgbModalModule,
    NgbModule,
    AnalyticsEventModule,
    PipesModule
],
  exports: [
    ConnectionCardComponent
  ]
})
export class ConnectionCardModule { }
